const bandOrders = [
  ['', 'All'],
  ['t', 'Single-band Thermal'],
  ['rgb', 'RGB - Red, Green, Blue'],
  ['rgn', 'RGN - Red, Green, NIR'],
  ['ngb', 'NGB - NIR, Green, Blue'],
  ['ngr', 'NGR - NIR, Green, Red'],
  ['nrg', 'NRG - NIR, Red, Green'],
  ['rgbn', 'RGBN - Red, Green, Blue, NIR'],
  ['rgbt', 'RGBT - Red, Green, Blue, LWIR'],
  ['gren', 'Mavic 3M / Parrot Sequoia (Green, Red, Red edge, NIR)'],
  ['bgren', 'MicaSense RedEdge/RedEdge-M (Blue, Green, Red, Red edge, NIR)'],
  ['bgrent', 'MicaSense Altum (Blue, Green, Red, Red edge, NIR, LWIR)'],
  ['bBgGrReEnN', 'MicaSense Dual Camera Imaging System'],
  ['vbgreEnNi', 'MAIA'],
]

export default bandOrders
